import React from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import { Sakums } from "pages";
import { connect } from "react-redux";
import loadingStatuss from "actions/LoadingActions";

const QUERY = gql`
  query PageHomeQuery($lang: String!) {
    menu(lang: $lang, _id: "primary") {
      items {
        title
        path
        rewrite_url
        rewrite_source
        rewrite_target
      }
    }
    searchLapa: page(lang: $lang, _id: 3660) {
      path
    }

    # aktuali(lang: $lang) {
    #   title
    #   date_created
    #   images {
    #     src
    #     alt
    #     thumb(size: "card-default") {
    #       url
    #       retina
    #       width
    #       height
    #     }
    #   }
    #   path
    #   acf
    #   post_type
    #   template
    #   rewrite_url
    #   rewrite_source
    #   rewrite_target
    # }

    saites(lang: $lang) {
      aktuali {
        menu_order
        path
        target
        title
      }
      noderigi {
        menu_order
        path
        target
        title
      }
      temas {
        menu_order
        path
        target
        title
      }
    }

    parpilsetu(lang: $lang) {
      title
      path
      images {
        thumb(size: "card-cover") {
          url
        }
      }
      post_type
      template
      rewrite_url
      rewrite_source
      rewrite_target
    }
    jaunumi(lang: $lang, perpage: 6, page: 0) {
      posts {
        path
        title
        date_created
        post_type
        template
      }
    }
    jaunumiLapa: page(lang: $lang, _id: 1516) {
      path
    }
    video_galerija(lang: $lang) {
      title
      path
      post_type
      template
      images {
        thumb(size: "card-video") {
          url
        }
      }
      acf
    }
    noderigi(lang: $lang) {
      nosaukums
      ikona
      post {
        path
        rewrite_url
        rewrite_source
        rewrite_target
      }
    }
    teksti(
      lang: $lang
      _id: [
        "sazinaties"
        "par_pilsetu"
        "jaunakas_zinas"
        "skatit_vairak_jaunumus"
        "video_galerija"
        "atskanot_video"
        "aizvert"
        "sazinas_forma"
        "sazinas_forma_apraksts"
        "vards"
        "uzvards"
        "kluda"
        "noradiet_precizu_informaciju"
        "tavs_e_pasts"
        "talrunis"
        "zina"
        "tava_zina"
        "obligatie_lauki"
        "jus_varat_pievienot_failu_sados_formatos"
        "pievienot_failu"
        "nosutit"
        "procesa"
        "paldies_zina_sanemta!"
        "pec_briza_pamegini_velreiz"
        "notikusi_kluda!"
        "labi"
        "meklet_lapas_satura"
        "es_mekleju"
        "aktuali"
        "noderigi"
        "temas"
        "atvert"
      ]
    ) {
      _id
      text
    }
  }
`;

const queryOptions = {
  options: ({ lang, postId, init_page }) => ({
    /* FIXME: Cache ir pie vainas, ka teksti, iespējams arī citas
    daļas mēdz neatjaunoties, jo dati tiek uzskatīti par identiskiem */
    fetchPolicy: "cache-first",
    variables: {
      postId: init_page.rewrite_id ? init_page.rewrite_id : postId,
      lang: lang || "lv",
    },
  }),
  props: (props) => {
    const {
      data: {
        loading,
        variables: { lang },
        page,
        menu,
        searchLapa,
        // aktuali,
        saites,
        parpilsetu,
        noderigi,
        jaunumi,
        jaunumiLapa,
        video_galerija,
        teksti,
        ...rest
      },
    } = props;

    return {
      loading,
      data: {
        page: [props.ownProps.init_page],
        menu,
        searchLapa,
        // aktuali,
        saites,
        parpilsetu,
        noderigi,
        jaunumi,
        jaunumiLapa,
        video_galerija,
        teksti,
        lang,
      },
    };
  },
};

class PageHome extends React.PureComponent {
  componentWillMount() {
    if (this.props.loading) {
      this.props.loadingStatuss({ _id: `${this.props.path}__`, loading: true });
    } else if (
      !this.props.loading &&
      this.props.global_loading &&
      this.props.global_loading[`${this.props.path}__`] === true
    ) {
      this.props.loadingStatuss({
        _id: `${this.props.path}__`,
        loading: false,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.loading &&
      nextProps.global_loading[`${nextProps.path}__`] === false
    ) {
      nextProps.loadingStatuss({ _id: `${nextProps.path}__`, loading: true });
    } else if (
      !nextProps.loading &&
      nextProps.global_loading[`${nextProps.path}__`] === true
    ) {
      nextProps.loadingStatuss({ _id: `${nextProps.path}__`, loading: false });
    }
  }

  render() {
    const props = this.props;

    if (props.loading) {
      return null;
    }

    return <Sakums data={props.data} />;
  }
}

const mapStateToProps = (state) =>
  // console.log(state)
  ({
    global_loading: state.global_loading,
  });

const mapDispatchToProps = (dispatch) => ({
  loadingStatuss: (LOADING) => {
    dispatch(loadingStatuss(LOADING));
  },
});

export default compose(
  graphql(QUERY, queryOptions),
  connect(mapStateToProps, mapDispatchToProps)
)(PageHome);



// WEBPACK FOOTER //
// ./src/components/PageHome.js